import React from "react";
import PropTypes from "prop-types";
import {
  HiCheckCircle,
  HiInformationCircle,
  HiExclamation,
  HiXCircle,
} from "react-icons/hi";

const ICONS = {
  success: {
    color: "text-emerald-500",
    icon: <HiCheckCircle />,
  },
  info: {
    color: "text-blue-500",
    icon: <HiInformationCircle />,
  },
  warning: {
    color: "text-yellow-500",
    icon: <HiExclamation />,
  },
  danger: {
    color: "text-red-500",
    icon: <HiXCircle />,
  },
};

const StatusIcon = (props) => {
  const { type, custom, iconColor } = props;

  const icon = ICONS[type];

  return (
    <span className={`text-2xl ${iconColor || icon.color}`}>
      {custom || icon.icon}
    </span>
  );
};

StatusIcon.defaultProps = {
  type: "info",
};

StatusIcon.propTypes = {
  type: PropTypes.oneOf(["info", "success", "warning", "danger"]),
  custom: PropTypes.node,
};

export default StatusIcon;
